import React from "react";
import Storifyme from "../components/Storifyme/Storifyme";

export default function test() {
	return (
		<div>
			<button
				type="button"
				onClick={() => {
					throw new Error("Sentry Frontend Error");
				}}
			>
				Throw error
			</button>
			<Storifyme widgetID={"8097"} />
		</div>
	);
}
